import React from "react";
import PropTypes from "prop-types";

import { clx } from "../../../../utils/Helpers";
import GenderCount from "./index";

import "./GenderCount.scss";

const GenderCountsGroup = ({
  maleLabel,
  femaleLabel,
  maleCount,
  femaleCount,
  className,
}) => (
  <div className={clx("gender-counts-group", className)}>
    <GenderCount variant="male" label={maleLabel} count={maleCount} />
    <span className="gender-counts-group__divider" aria-hidden />
    <GenderCount variant="female" label={femaleLabel} count={femaleCount} />
  </div>
);

GenderCountsGroup.propTypes = {
  maleLabel: PropTypes.string.isRequired,
  femaleLabel: PropTypes.string.isRequired,
  maleCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  femaleCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
};

GenderCountsGroup.defaultProps = {
  maleCount: 0,
  femaleCount: 0,
  className: undefined,
};

export default GenderCountsGroup;
